(function () {
  'use strict';
  var urlParams = new URLSearchParams(window.location.search);
  var fromBusiness = urlParams.get('from_business') === '1';
  var pathname = window.location.pathname;
  var isBusinessPage = pathname.includes('/pages/business') || pathname.includes('/collections/business-');

  if (isBusinessPage) {
    var paths = ['/account', '/cart', '/products', '/search'];
    var addParam = function (url) {
      return url && !url.includes('from_business=1') ? url + (url.includes('?') ? '&' : '?') + 'from_business=1' : url;
    };

    var process = function () {
      var links = document.querySelectorAll(
        'a[href^="/account"], a[href^="/cart"], a[href^="/products"], a[href^="/search"]'
      );
      links.forEach(function (link) {
        var href = link.getAttribute('href');
        if (href && paths.some(function (p) { return href.startsWith(p); })) {
          link.setAttribute('href', addParam(href));
        }
      });

      var forms = document.querySelectorAll('form[action*="/search"]');
      forms.forEach(function (form) {
        if (!form.querySelector('input[name="from_business"]')) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'from_business';
          input.value = '1';
          form.appendChild(input);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', process, { once: true });
    } else {
      process();
    }
  }

  var targetPaths = ['/account', '/cart', '/products', '/search'];
  var isTargetPage = targetPaths.some(function (path) { return pathname.includes(path); });

  if (!isTargetPage || !fromBusiness || document.querySelector('.business-header')) {
    return;
  }

  var normalHeader = document.querySelector('.v2-header-sticky');
  if (normalHeader) {
    normalHeader.style.display = 'none';
  }

  Promise.all([
    fetch('/pages/business').then(function (r) { return r.text(); }),
    new Promise(function (resolve) {
      if (document.readyState === 'complete') {
        resolve();
      } else {
        window.addEventListener('load', resolve, { once: true });
      }
    }),
  ])
    .then(function (results) {
      var html = results[0];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var header = doc.querySelector('.business-header');
      var pageHead = doc.querySelector('.business-pageHead');

      if (!header) return;

      var styles = Array.from(doc.querySelectorAll('link[href*="page-business"], link[href*="typekit"]'));
      var stylePromises = styles.map(function (link) {
        var href = link.getAttribute('href');
        if (document.querySelector('link[href="' + href + '"]')) {
          return Promise.resolve();
        }

        return new Promise(function (resolve) {
          var linkEl = document.createElement('link');
          linkEl.rel = 'stylesheet';
          linkEl.href = href;
          linkEl.onload = resolve;
          linkEl.onerror = resolve;
          document.head.appendChild(linkEl);
        });
      });

      return Promise.all(stylePromises).then(function () {
        var container = document.querySelector('.page-container');
        if (!container || !container.parentNode) return;

        if (pageHead) {
          var div = document.createElement('div');
          div.className = 'business-pageHead-container';
          div.innerHTML = pageHead.outerHTML;
          container.parentNode.insertBefore(div, container);
        }

        var headerDiv = document.createElement('div');
        headerDiv.className = 'business-header-container';
        headerDiv.innerHTML = header.outerHTML;
        container.parentNode.insertBefore(headerDiv, container);

        if (pathname.includes('/products/')) {
          var banner = document.createElement('a');
          banner.href = '/pages/business-contact-order?request_detail_2507=bulk250';
          banner.className = 'business-products-banner';
          banner.innerHTML =
            '<div class="business-products-banner-inner"><p class="business-products-banner-text">総額250万円以上・大口のご注文をご検討のお客様へ <span class="business-products-banner-link">法人担当へ相談する<span class="business-products-banner-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg></span></span></p></div>';
          container.parentNode.insertBefore(banner, container);
        }

        var scripts = Array.from(doc.querySelectorAll('script[src*="page-business"]'));
        var scriptPromises = scripts.map(function (script) {
          var src = script.getAttribute('src');
          if (document.querySelector('script[src="' + src + '"]')) {
            return Promise.resolve();
          }

          return new Promise(function (resolve) {
            var s = document.createElement('script');
            s.src = src;
            s.async = false;
            s.onload = resolve;
            s.onerror = resolve;
            document.head.appendChild(s);
          });
        });

        Promise.all(scriptPromises).then(function () {
          var breakpoint = 1080;
          if (window.innerWidth <= breakpoint) return;

          var menuButtons = document.querySelectorAll('.js-menuBtns li');
          if (!menuButtons.length) return;

          var closeTimer = null;
          var menuSelector = '.js-menuContent';

          var updateBodyState = function () {
            var hasOpen = document.querySelector('.business-menu.is-show');
            document.body.classList.toggle('is-menu-active', !!hasOpen);
          };

          var closeAllMenus = function () {
            menuButtons.forEach(function (button) {
              var content = button.querySelector(menuSelector);
              if (content) content.classList.remove('is-show');
              button.classList.remove('is-active');
            });
            updateBodyState();
          };

          menuButtons.forEach(function (button) {
            var content = button.querySelector(menuSelector);
            if (!content) return;

            var openMenu = function () {
              if (closeTimer) {
                clearTimeout(closeTimer);
                closeTimer = null;
              }
              closeAllMenus();
              content.classList.add('is-show');
              button.classList.add('is-active');
              updateBodyState();
            };

            var closeMenu = function () {
              if (closeTimer) clearTimeout(closeTimer);
              closeTimer = setTimeout(closeAllMenus, 100);
            };

            button.addEventListener('mouseenter', openMenu);
            button.addEventListener('mouseleave', closeMenu);
            content.addEventListener('mouseenter', function () {
              if (closeTimer) {
                clearTimeout(closeTimer);
                closeTimer = null;
              }
            });
            content.addEventListener('mouseleave', closeMenu);
          });
        });
      });
    })
    .catch(function (e) { console.error('Error loading business header:', e); });
})();
